import api from "../services/admin_api_global";

// ── Global Settings ──────────────────────────────────────
export const getGlobalSettings = () =>
  api.get("/admin/calendar/global/settings");

export const saveGlobalSettings = (data) =>
  api.put("/admin/calendar/global/settings", data);

// ── Global Calendar ──────────────────────────────────────
export const getGlobalCalendar = (month) =>
  api.get("/admin/calendar/global", { params: { month } });

export const createGlobalOverride = (data) =>
  api.post("/admin/calendar/global/override", data);

export const deleteGlobalOverride = (overrideId) =>
  api.delete(`/admin/calendar/global/override/${overrideId}`);

// ── Batch Settings ───────────────────────────────────────
export const getBatchCalendarSettings = (batchId) =>
  api.get(`/admin/calendar/batch/${batchId}/settings`);

export const saveBatchCalendarSettings = (batchId, data) =>
  api.put(`/admin/calendar/batch/${batchId}/settings`, data);

export const resetBatchCalendarSettings = (batchId) =>
  api.delete(`/admin/calendar/batch/${batchId}/settings`);

// ── Batch Calendar ───────────────────────────────────────
export const getBatchCalendar = (batchId, month) =>
  api.get(`/admin/calendar/batch/${batchId}`, { params: { month } });

export const createBatchOverride = (batchId, data) =>
  api.post(`/admin/calendar/batch/${batchId}/override`, data);

export const deleteBatchOverride = (batchId, overrideId) =>
  api.delete(`/admin/calendar/batch/${batchId}/override/${overrideId}`);

// ── Unavailability ───────────────────────────────────────
export const getBatchUnavailability = (batchId) =>
  api.get(`/admin/calendar/batch/${batchId}/unavailability`);

export const reviewUnavailability = (requestId, data) =>
  api.patch(`/admin/calendar/unavailability/${requestId}`, data);
